import { Injectable } from '@angular/core';
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { TextboxControl } from "../../dynamic-form/textbox-control";
import { PasswordControl } from "../../dynamic-form/password-control";
import { AutoCompleteControl } from "../../dynamic-form/auto-complete-control";
import { DropdownControl } from "../../dynamic-form/dropdown-control";
import { RoleService } from "../role/role.service";

@Injectable()
export class UserManagementFieldService {

    public getFields(): Array<FormControlBase<any>> {
        let fields = new Array<FormControlBase<any>>();

        let mobileNumberField = new TextboxControl();
        mobileNumberField.key = 'mobileNumber';
        mobileNumberField.label = 'Mobile Number';
        mobileNumberField.placeHolder = 'Enter mobile number';
        mobileNumberField.order = 1;
        mobileNumberField.validNumberOnly = true;
        mobileNumberField.required = true;
        mobileNumberField.preventKeys = '\\d';
        fields.push(mobileNumberField);

        let emailField = new TextboxControl();
        emailField.key = 'email';
        emailField.label = 'Email';
        emailField.placeHolder = 'Enter email';
        emailField.order = 2;
        emailField.required = true;
        emailField.validEmail = true;
        fields.push(emailField);

        let firstNameField = new TextboxControl();
        firstNameField.key = 'firstName';
        firstNameField.label = 'First Name';
        firstNameField.placeHolder = 'Enter first name'
        firstNameField.order = 3;
        firstNameField.required = true;
        firstNameField.validNoNumber = true;
        firstNameField.preventKeys = '[a-zA-Z]';
        fields.push(firstNameField);

        let surnameField = new TextboxControl();
        surnameField.key = 'surname';
        surnameField.label = 'Surname';
        surnameField.placeHolder = 'Enter surname';
        surnameField.order = 4;
        surnameField.required = true;
        surnameField.preventKeys = '[a-zA-Z]';
        fields.push(surnameField);

        let locationField = new AutoCompleteControl();
        locationField.key = 'loyaltySiteName';
        locationField.label = 'Location';
        locationField.placeHolder = 'Enter location';
        locationField.order = 5;
        fields.push(locationField);

        let passwordField = new PasswordControl();
        passwordField.key = 'password';
        passwordField.label = 'Password';
        passwordField.placeHolder = 'Enter password';
        passwordField.order = 6;
        fields.push(passwordField);

        let confirmPasswordField = new PasswordControl();
        confirmPasswordField.key = 'confirmPassword';
        confirmPasswordField.label = 'Confirm Password';
        confirmPasswordField.placeHolder = 'Enter confirm password';
        confirmPasswordField.order = 7;
        fields.push(confirmPasswordField);

        let roleField = new DropdownControl();
        roleField.key = 'roleId';
        roleField.label = 'Role';
        roleField.order = 8;
        fields.push(roleField);

        return fields.sort((a, b) => a.order - b.order);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user-management-field.service.ts